import { CHAR_REGEX_STR } from './regex';
export var DEFAULT_CHAR_REGEX = new RegExp(CHAR_REGEX_STR);
var SYSTEM_TAG_PREFIX = 'aws:';
var MAX_KEY_LENGTH = 128;
var MAX_VALUE_LENGTH = 256;
export var awsPrefixCheck = function (value) {
    if (value === void 0) { value = ''; }
    return value.toLowerCase().indexOf(SYSTEM_TAG_PREFIX) === 0;
};
export var emptyKeyCheck = function (value) {
    if (value === void 0) { value = ''; }
    return !value || value.trim().length === 0;
};
export var maxKeyLengthCheck = function (value) {
    if (value === void 0) { value = ''; }
    return value && value.length > MAX_KEY_LENGTH;
};
export var duplicateKeyCheck = function (value, tags) {
    if (value === void 0) { value = ''; }
    // Empty keys are valid
    if (!value) {
        return true;
    }
    return tags.filter(function (tag) { return tag.key === value && !tag.markedForRemoval; }).length <= 1;
};
export var maxValueLengthCheck = function (value) {
    if (value === void 0) { value = ''; }
    return value && value.length > MAX_VALUE_LENGTH;
};
export var invalidCharCheck = function (value, validCharRegex) {
    if (value === void 0) { value = ''; }
    if (validCharRegex === void 0) { validCharRegex = DEFAULT_CHAR_REGEX; }
    // Empty values are valid
    if (!value || !validCharRegex) {
        return false;
    }
    return !validCharRegex.test(value);
};
//# sourceMappingURL=rules.js.map